<template>
  <v-card outlined class="rounded-lg">
    <v-img :src="'/static/calendarEventImages/img_kerzen_1x.jpg'" height="100px">
      <v-card-title class="white--text">{{ semester }}-Semesterbänder <br />{{ currentYear }}</v-card-title>
    </v-img>
    <v-card-text class="pa-0">
      <div class="body-2 pa-4" v-if="jubilaeum.length === 0">Keine anstehenden Runden Jubiläen</div>
      <v-simple-table fixed-header dense class="rounded-lg">
        <tbody>
          <tr
            v-for="item in jubilaeum"
            :key="item.id"
            @click="
              bbr = item.bbr;
              showKontakt = true;
            "
          >
            <td>{{ $filters.date(item.receptionsdatum, "DD.MM.") }}</td>
            <td>
              {{ $filters.user(item.bbrID, bbrbbr) }}
              <!-- ({{item.alter * 2}} Semester) -->
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: ["semester"],
    data() {
      return {
        bbr: {},
        showKontakt: false,
        currentYear: new Date().getFullYear(),
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      jubilaeum() {
        const bbrbbr = this.$store.getters["bbrbbr/nurBbrbbr"];
        // const heute = new Date().setDate(new Date().getDate() - 1)
        const heute = new Date(new Date().getFullYear(), 0, 1);
        const ergebnis = bbrbbr
          .filter((bbr) => bbr.receptionsdatum)
          .map((bbr) => {
            const receptionsdatum = new Date(bbr.receptionsdatum);
            const alter = new Date().getFullYear() - receptionsdatum.getFullYear();
            return {
              bbr: bbr,
              bbrID: bbr.id,
              receptionsdatum,
              alter,
            };
          })
          .flatMap((item) => {
            const newItem1 = {
              ...item,
              receptionsdatum: new Date(new Date(item.receptionsdatum).setFullYear(new Date().getFullYear())),
            };
            // const newItem2 = {...item, receptionsdatum: new Date(new Date(item.receptionsdatum).setFullYear(new Date().getFullYear() + 1))}
            // return [newItem1, newItem2]
            return [newItem1];
          })
          .filter((item) => item.receptionsdatum >= heute)
          .filter((item) => item.alter % (this.semester / 2) === 0 && item.alter >= 1)
          .sort((a, b) => a.receptionsdatum - b.receptionsdatum);
        // .slice(0, 10)
        return ergebnis;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// jubilaum.vue?69c606f8